// extracted by mini-css-extract-plugin
module.exports = {"toolTipWrap":"NewTooltip_toolTipWrap__2lI_Q","infoWrap":"NewTooltip_infoWrap__3oa0l","infoTitle":"NewTooltip_infoTitle__WDeRp","infoBody":"NewTooltip_infoBody__1MWMd"};